module.exports = __webpack_public_path__ + "img/S05.6c528424.png";